import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-views.title',
		defaultMessage: 'Views you can use',
		description: 'The title of the spotlight',
	},
	content: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-views.content',
		defaultMessage:
			'Issues are just one part of your plan. Use this menu to view releases and teams included in your plan, plus other layers of information.',
		description: 'The content for the spotlight',
	},
	heading: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-views.heading',
		defaultMessage: 'Views for different needs',
		description: 'The title of the spotlight',
	},
	description: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-views.description',
		defaultMessage:
			'Each page shows you a different aspect of your plan so you can quickly find the information you need.',
		description: 'The content for the spotlight',
	},
});
